import { usePathname, useRouter } from 'next/navigation';
import { JSX, PropsWithChildren, useState } from 'react';

import { Button } from '@videoblocks/design-system';

import AiRiskModal from '../../../../components/aiRiskModal';
import { AI_USER_SEGMENTS } from '../../ai/_shared/_context/types';
import { useVoiceoverContext } from '../_context/VoiceoverContext';
import { useVoiceoverGenerationBridge } from '../_context/VoiceoverGenerationBridge';
import { updateOptIns } from '../actions/optIn';
import Modal from './Modal';

// import UpgradeSubscriptionModal from './UpgradeSubscriptionModal';

interface GenerateButtonProps extends PropsWithChildren {
    className?: string;
    onSubmit: () => void;
    disabled?: boolean;
    calculatedCost: number;
}

export default function GenerateButton({
    className,
    onSubmit,
    disabled,
    calculatedCost,
    children,
}: GenerateButtonProps): JSX.Element {
    const location = usePathname();
    const { credits, optIns, subscription, voiceoverSegment, isEnterprise } = useVoiceoverContext();
    const { submitDisabled } = useVoiceoverGenerationBridge();
    // const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAiRiskModalOpen, setIsAiRiskModalOpen] = useState(false);
    const [isEnterpriseModalOpen, setIsEnterpriseModalOpen] = useState(false);
    const [isAiVoiceoverOptIn, setIsAiVoiceoverOptIn] = useState(optIns?.aiVoiceover);
    const router = useRouter();

    return (
        <>
            {/* holding off on modal UMP flow for launch */}
            {/*<UpgradeSubscriptionModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />*/}
            <Modal
                isOpen={isEnterpriseModalOpen}
                onClose={() => setIsEnterpriseModalOpen(false)}
                onConfirm={() => {
                    setIsEnterpriseModalOpen(false);
                    router.push('/member/support');
                }}
                title="Enterprise Feature Access"
                body="Please contact your Success Team to gain access to this feature."
                primaryActionText="Contact Now"
            />
            <AiRiskModal
                isOpen={isAiRiskModalOpen}
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onAccept={async () => {
                    await updateOptIns('aiVoiceover');
                    setIsAiVoiceoverOptIn(true);
                    onSubmit();
                    setIsAiRiskModalOpen(false);
                }}
                onClose={() => setIsAiRiskModalOpen(false)}
            />
            <Button
                className={className}
                data-testid="submit"
                disabled={disabled || submitDisabled}
                size="large"
                onClick={() => {
                    const redirectQueryParam = `redirectAfterRegister=${encodeURIComponent(location)}`;

                    if (voiceoverSegment === AI_USER_SEGMENTS.UNSUBSCRIBED) {
                        // sees features, button goes to pricing
                        router.push(`/pricing?${redirectQueryParam}`);
                    } else if (voiceoverSegment === AI_USER_SEGMENTS.UPGRADABLE) {
                        if (isEnterprise) {
                            setIsEnterpriseModalOpen(true);
                        } else {
                            // setIsModalOpen(true);
                            router.push(`/video/upgrade-my-plan/${subscription?.id}?${redirectQueryParam}`);
                        }
                    } else if (voiceoverSegment === AI_USER_SEGMENTS.SUBSCRIBED) {
                        if (!isAiVoiceoverOptIn) {
                            // show ai risk modal
                            setIsAiRiskModalOpen(true);
                            return;
                        }

                        if (credits === 0 || calculatedCost > credits) {
                            if (isEnterprise) {
                                setIsEnterpriseModalOpen(true);
                            } else {
                                router.push(`/video/upgrade-my-plan/${subscription?.id}?${redirectQueryParam}`);
                            }
                            return;
                        }

                        onSubmit();
                    }
                }}
            >
                {children}
            </Button>
        </>
    );
}
